
export class Email {
    private static readonly emailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

    private address: string;

    private constructor(address: string) {
        this.address = address;
    }

    static fromString(email: string) {
        email = email.trim().toLowerCase();
        if (!email && !email.trim()) {
            throw new Error('E-mail é obrigatório.');
        }

        if (email.length <= 3) {
            throw new Error('E-mail muito curto');
        }

        if (!this.emailRegex.test(email)) {
            throw new Error('E-mail inválido.');
        }

        return new Email(email);
    }

    toString() {
        return this.address;
    }
}